<!--
 * @Author: your name
 * @Date: 2021-09-20 10:09:13
 * @LastEditTime: 2021-12-26 16:26:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\views\PC\saveMyTask\saveMyTask.vue
-->
<template>
  <div class="create-project-task">
    <bounty-back :title="$t('ProjectTask.PublishedTasks')" @goBack="goBack"></bounty-back>
    <div class="my-title">{{$t('ProjectTask.CreateABountyTask')}}</div>
      <el-form ref="form" id="form_my" :label-position="'top'" class="form_wrap" style="padding-bottom: 0px;">
        <div class="form-box">
          <el-form-item :label="$t('ProjectTask.Project')">
            <el-select v-model="formData.projectId" @change="changeProject">
              <el-option v-for="(item,index) in projectList" :key="index + '_' + item" :label="item.projectName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <bounty-project-detail v-if="projectDetail.name" style="margin-top: 23px;" class="bounty-project-detail" :projectDetail="projectDetail"></bounty-project-detail>
        <div class="form-box">
          <el-form-item class="required" :label="$t('ProjectTask.TaskSubject')">
            <el-input v-model="formData.taskTheme" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item class="required" :label="$t('ProjectTask.TaskType')">
            <el-select v-model="formData.taskType">
              <el-option v-for="(item,index) in taskTypeList2" :key="index + '_' + item" :label="item.name_en" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-box">
          <el-form-item class="required" :label="$t('ProjectTask.ActivityDate')">
            <el-date-picker
              v-model="timeArray"
              type="daterange"
              :range-separator="$t('ProjectTask.to')"
              :start-placeholder="$t('ProjectTask.startTime')"
              :end-placeholder="$t('ProjectTask.endTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="total-rewards" required="" :label="$t('ProjectTask.TotalRewards')">
            <el-input v-model="formData.totalAwards" maxlength="10">
              <el-select slot="suffix" v-model="formData.paymentTokensId"  @change="changeTokens">
                <el-option v-for="(item,index) in paymentTokensList" :key="index + '_' + item" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-input>
            <div class="img-box">
              <img v-if="imgBoxSrc" :src="imgBoxSrc" alt="img">
            </div>
          </el-form-item>
        </div>
        <div class="form-box">
          <el-form-item class="required" :label="$t('ProjectTask.TheNumberOfParticipants')">
            <el-input v-model="formData.numberOf" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ProjectTask.AcceptanceCriteria')">
            <el-input v-model="formData.acceptanceCriteria" maxlength="100"></el-input>
          </el-form-item>
        </div>
        <div class="form-box" v-if="false">
          <el-form-item class="required" :label="$t('ProjectTask.TaskNature')">
            <el-select v-model="formData.taskNature">
              <el-option v-for="(item,index) in taskTypeList" :key="index + '_' + item" :label="item.name_en" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('ProjectTask.PaymentTokensId')" v-if="false">
            <!-- <el-input v-model="formData.paymentTokensId"></el-input> -->
            <el-select v-model="formData.paymentTokensId" @change="changeTokens">
              <el-option v-for="(item,index) in paymentTokensList" :key="index + '_' + item" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item class="required" :label="$t('ProjectTask.TaskDescribe')">
          <el-input maxlength="1000" type="textarea" :autosize="{minRows:6}" v-model="formData.taskDetails"></el-input>
        </el-form-item>
        <div class="form-box">
          <el-form-item :label="$t('ProjectTask.ContactInformation')">
            <el-input maxlength="50" v-model="formData.contactInformation"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ProjectTask.NFTContractAddress')">
            <el-input maxlength="50" v-model.trim="formData.nftContractId"></el-input>
          </el-form-item>
        </div>
        <div class="form-box">
          <el-form-item :label="$t('ProjectTask.Country')">
            <el-select v-model="formData.country">
              <el-option v-for="(item,index) in countryList" :key="index + '_' + item" :label="item.name_en" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <div v-if="!isView" style="margin-right: 20px;" class="saveBtn cancelselect" @click="createTaskFn">{{$t('My.Save')}}</div>
          <div v-if="!isView" class="saveBtn cancelselect" @click="submitTask">{{$t('planDialog.Submit')}}</div>
        </div>
      </el-form>
      <bounty-tip v-if="showTip" :content="$t('ProjectTask.tipDialog')" :approveBtn="approveBtn" :approveDisable="approveDisable" :cancelBtn="$t('ProjectTask.cancel')" :sureBtn="$t('ProjectTask.confirm')" @sure="submitTaskFn" @approve="approveFn" @close="close"></bounty-tip>
  </div>
</template>

<script>
import { getPaymentTokensList, getTaskById, submitMyTask, saveMyTask, createTask, getMyProjectList, getProjectById, selectDictByParentCode, getId } from '@/api/bounty.js'
import dayjs from 'dayjs'
import { eventBus } from '@/plugin/eventBus/index.js'
import { format } from 'js-conflux-sdk'
import BigNumber from 'bignumber.js'
let allowanceBounty
export default {
  name: 'createProjectTask',
  data () {
    return {
      countryList: [],
      addressT: '',
      currencyCon: '',
      allowance: '',
      waitLoading: '',
      approveBtn: false, // 授权是否展示
      approveDisable: true, // 授权时控制谁可以点击
      imgBoxSrc: '',
      showTip: false,
      inprocess: false, // 提交方案中
      timeArray: [],
      formData: {
        id: '',
        taskTheme: '',
        taskNature: '',
        projectId: '',
        taskType: '',
        taskDetails: '',
        paymentTokensId: '',
        totalAwards: '',
        numberOf: '',
        unitPrice: '',
        nftContractId: '',
        acceptanceCriteria: '',
        startDate: '',
        closingDate: '',
        contactInformation: '',
        country: ''
      },
      projectList: [],
      select1: '',
      projectDetail: {
        icon: '',
        name: '',
        descripton: ''
      },
      taskTypeList: [],
      taskTypeList2: [], // taskType
      paymentTokensList: [],
      tokenAddress: '' // 合约地址
    }
  },
  props: ['DATA', 'isEdit', 'isView'],
  mounted () {
    // console.log('this.DATA', this.DATA)
    // console.log(format.hexAddress('cfxtest:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa6f0vrcsw'))
    eventBus.$on('createProjectTaskDictChange', () => {
      this.getDict()
    })
    this.getAllProject()
    this.getDict()
    if (this.DATA && this.DATA.id) {
      getTaskById({ id: this.DATA.id }).then(res => {
        if (!res.code) {
          // console.log(res)
          const obj = res.data.task
          this.formData = {
            id: obj.id,
            taskTheme: obj.taskTheme,
            taskNature: obj.taskNature,
            projectId: obj.projectId,
            taskType: obj.taskType,
            taskDetails: obj.taskDetails,
            paymentTokensId: obj.paymentTokensId,
            totalAwards: obj.totalAwards,
            numberOf: obj.numberOf,
            unitPrice: obj.unitPrice,
            nftContractId: obj.nftContractId,
            acceptanceCriteria: obj.acceptanceCriteria,
            startDate: obj.startDate,
            closingDate: obj.closingDate,
            contactInformation: obj.contactInformation,
            country: obj.country
          }
          this.timeArray = [this.formData.startDate, this.formData.closingDate]
          // 设置tokenAdress

          // 设置项目
          this.changeProject(obj.projectId)
          getPaymentTokensList({
            count: 0,
            pageSize: 300
          }).then(res1 => {
            if (!res1.code) {
              if (res1.data && res1.data.paymentTokensList) {
                this.paymentTokensList = res1.data.paymentTokensList || []
                if (this.paymentTokensList.filter(item => item.id === this.formData.paymentTokensId)[0]) {
                  this.imgBoxSrc = this.paymentTokensList.filter(item => item.id === this.formData.paymentTokensId)[0].icon
                  this.tokenAddress = format.hexAddress(this.paymentTokensList.filter(item => item.id === this.formData.paymentTokensId)[0].contractAddress)
                  // console.log(this.tokenAddress, 'this.tokenAddress ')
                } else {
                  this.imgBoxSrc = ''
                }
              }
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }).catch(err => {
        console.log(err)
      })
    } else {
      getPaymentTokensList({
        count: 0,
        pageSize: 300
      }).then(res => {
        if (!res.code) {
          this.paymentTokensList = res.data.paymentTokensList || []
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  methods: {
    /**
     * @description: 获取字典内容
     * @param {*}
     * @return {*}
     */
    getDict () {
      // 查询任务性质
      selectDictByParentCode({ parentCode: 'bty_identity_category' }).then(res => {
        if (!res.code) {
          if (res.data.dict.length) {
            if (localStorage.getItem('languageBounty') === 'cn') {
              res.data.dict = res.data.dict.map(item => {
                item.name_en = item.name
                return item
              })
            }
            this.taskTypeList = res.data.dict
          }
        }
      }).catch(err => {
        console.log(err)
      })
      // 查询任务类型
      selectDictByParentCode({ parentCode: 'bty_task_type' }).then(res => {
        if (!res.code) {
          if (res.data.dict.length) {
            if (localStorage.getItem('languageBounty') === 'cn') {
              res.data.dict = res.data.dict.map(item => {
                item.name_en = item.name
                return item
              })
            }
            this.taskTypeList2 = res.data.dict
          }
        }
      }).catch(err => {
        console.log(err)
      })
      // 查询城市
      selectDictByParentCode({ parentCode: 'bty_country' }).then(res => {
        if (!res.code) {
          if (res.data.dict.length) {
            if (localStorage.getItem('languageBounty') === 'cn') {
              res.data.dict = res.data.dict.map(item => {
                item.name_en = item.name
                return item
              })
            }
            this.countryList = res.data.dict
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 修改tokens
     * @param {*}
     * @return {*}
     */
    changeTokens (val) {
      try {
        if (this.paymentTokensList.filter(item => item.id === val)[0]) {
          this.imgBoxSrc = this.paymentTokensList.filter(item => item.id === val)[0].icon
          this.tokenAddress = format.hexAddress(this.paymentTokensList.filter(item => item.id === val)[0].contractAddress)
        } else {
          this.imgBoxSrc = ''
          this.tokenAddress = ''
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description: 关闭弹窗
     * @param {*}
     * @return {*}
     */
    close () {
      this.showTip = false
    },
    /**
     * @description: 展示弹窗
     * @param {*}
     * @return {*}
     */
    async submitTask () {
      try {
        if (!this.checkForm()) {
          return false
        }
        if (this.paymentTokensList.filter(item => item.id === this.formData.paymentTokensId)[0]?.name === 'CFX') { // cfx 带value 不是cfx 不带value
          this.approveBtn = false // 不需要展示授权按钮
        } else {
          // 检查是否需要授权按钮
          this.addressT = CONTRAC_ADRESS_BONTY// 质押合约地址
          // 代币合约
          console.log('this.tokenAddress', this.tokenAddress)
          console.log('CONTRACT_ABI2', CONTRACT_ABI2)
          this.currencyCon =
          window.conflux &&
          window.confluxJS.Contract({
            address: this.tokenAddress, // 下拉菜单地址
            abi: CONTRACT_ABI2
          })
          // 获取已授权额度
          allowanceBounty = await this.currencyCon.allowance(
            format.hexAddress(sessionStorage.getItem('walletAddress')), // 授权用户 当前钱包地址
            format.hexAddress(CONTRAC_ADRESS_BONTY) // 质押合约地址 // 转账地址
          )
          // console.log(allowanceBounty, 'allowanceBounty')
          // console.log(allowanceBounty / 1e18)
          // console.log(this.formData.totalAwards)
          // console.log(allowanceBounty / 1e18 >= this.formData.totalAwards, '222222222')
          if (allowanceBounty / 1e18 >= this.formData.totalAwards) {
            this.approveBtn = false // 不需要展示授权按钮
          } else {
            this.approveBtn = true // 需要展示授权按钮
            this.approveDisable = true // 确认不可点击
          }
        }
        this.showTip = true
      } catch (error) {
        this.showTip = false
        this.approveBtn = false // 不需要展示授权按钮
        this.waitLoading.close()
      }
      //
    },
    async approveFn () {
      if (allowanceBounty / 1e18 === 0) {
        // 打开钱包
        const accounts = await conflux.request({ method: 'cfx_requestAccounts' }) // 打开钱包
        if (accounts[0] !== sessionStorage.getItem('walletAddress')) {
          this.$message({
            type: 'warning',
            offset: 120,
            message: this.$t('allTip.tip27')
          })
          eventBus.$emit('openWallet')
          this.$router.push({ name: 'Index' })
          return
        }
        this.waitLoading = this.$loading({ lock: true, text: this.$t('My.approving'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        await this.currencyCon
          .approve(
            format.hexAddress(this.addressT),
            new BigNumber(100000000).times(new BigNumber(1e18)).toFixed()
          )
          .sendTransaction({ from: accounts[0], gas: 140000, gasPrice: 10001 })
          .executed()
        this.waitLoading.close()
        this.approveDisable = false // 确认可点击
        console.log('执行')
      } else {
        // await currencyCon
        //   .approve(format.hexAddress(addressT), new BigNumber(0).times(new BigNumber(1e18)).toFixed())
        //   .sendTransaction({ from: accounts[0], gas: 140000, gasPrice: 10001 })
        //   .executed()
        // return false
      }
    },
    /**
     * @description: 修改项目
     * @param {*}
     * @return {*}
     */
    changeProject (val) {
      // console.log(val)
      if (!val) {
        this.projectDetail = {
          icon: '',
          name: '',
          descripton: ''
        }
      } else {
        getProjectById({ id: val }).then(res => {
          if (!res.code) {
            console.log(res)
            const obj = res.data.project
            this.projectDetail = {
              icon: obj.logo,
              name: obj.entryName,
              descripton: obj.remarks
            }
            console.log(this.projectDetail)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    /**
     * @description: 获取项目列表
     * @param {*}
     * @return {*}
     */
    getAllProject () {
      getMyProjectList().then(res => {
        if (!res.code) {
          this.projectList = [{ id: '', projectName: '' }].concat(res.data.projectList.map(item => {
          // this.projectList = res.data.projectList.map(item => {
            return {
              id: item.id,
              projectIcon: item.logo,
              projectName: item.entryName,
              projectDesc: item.remarks,
              projectType: item.projectType,
              ProjectURL: item.projectWebsite,
              createTime: item.creationTime ? item.creationTime : ''
            }
          }))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 返回
     * @param {*}
     * @return {*}
     */
    goBack () {
      this.$emit('backMy')
    },
    /**
     * @description: 检查表单
     * @param {*}
     * @return {*}
     */
    checkForm () {
      if (!this.formData.taskTheme) {
        this.$message({
          message: this.$t('allTip.tip12'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (!this.formData.taskType) {
        this.$message({
          message: this.$t('allTip.tip13'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (this.timeArray.length === 0) {
        this.$message({
          message: this.$t('allTip.tip14'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (!this.formData.totalAwards) {
        this.$message({
          message: this.$t('allTip.tip15'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (!/(^[0-9]\d*$)/.test(this.formData.totalAwards)) {
        this.$message({
          message: this.$t('allTip.tip16'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (!this.formData.paymentTokensId) {
        this.$message({
          message: this.$t('allTip.tip25'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (!this.formData.numberOf) {
        this.$message({
          message: this.$t('allTip.tip17'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (!/(^[1-9]\d*$)/.test(this.formData.numberOf)) {
        this.$message({
          message: this.$t('allTip.tip18'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      const testNum = this.formData.totalAwards / this.formData.numberOf
      if (!/(^[0-9]\d*$)/.test(testNum)) {
        this.$message({
          message: this.$t('allTip.tip19'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      this.formData.unitPrice = testNum
      // if (!this.formData.taskNature) {
      //   this.$message({
      //     message: this.$t('allTip.tip20'),
      //     offset: 120,
      //     type: 'warning'
      //   })
      //   return false
      // }
      if (!this.formData.taskDetails) {
        this.$message({
          message: this.$t('allTip.tip21'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      if (Number(this.formData.totalAwards) === 0 && !this.formData.nftContractId) {
        // NFT Contract Address Must Input
        this.$message({
          message: this.$t('allTip.tip23'),
          offset: 120,
          type: 'warning'
        })
        return false
      }
      return true
    },
    /**
     * @description: 创建任务
     * @param {*}
     * @return {*}
     */
    async createTaskFn () {
      if (!this.checkForm()) {
        return false
      }
      this.formData.startDate = dayjs(this.timeArray[0]).format('YYYY-MM-DD')
      this.formData.closingDate = dayjs(this.timeArray[1]).format('YYYY-MM-DD')
      // let res
      try {
        let resId = ''
        if (!this.formData.id) {
          resId = await getId()
          if (!resId.code) {
            this.formData.id = resId.data.id
          }
        }
        // const taskId = this.formData.id
        // // const tokenAddress = sessionStorage.getItem('walletAddress')
        // // const tokenAddress = 'cfxtest:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa6f0vrcsw'
        // const tokenAddress = '0x0000000000000000000000000000000000000000'
        // // const tokenAddress = 'cfxtest:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa6f0vrcsw'
        // // const unitPrice = this.Data.unitPrice * this.Data.numberOf
        // const unitPrice = this.formData.unitPrice * 1000000000000000000
        // // const maxWorkers = this.Data.totalAwards
        // const maxWorkers = this.formData.numberOf
        // console.log(taskId, tokenAddress, unitPrice, maxWorkers)
        // console.log(sessionStorage.getItem('walletAddress'))
        // // console.log(this.$root.contract)
        // const startTask = await this.$root.contract.addTask(taskId, tokenAddress, unitPrice, maxWorkers).sendTransaction({
        //   from: sessionStorage.getItem('walletAddress'),
        //   value: this.formData.unitPrice * this.formData.numberOf * 1000000000000000000
        // }).executed()
        // res = {
        //   state: true,
        //   data: startTask.transactionHash
        // }
        // console.log('res', res)
        saveMyTask(this.formData).then(res => {
          if (!res.code) {
            this.goBack()
            this.$message({
              type: 'success',
              offset: 120,
              message: 'success'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      } catch (err) {
        console.log(err)
      }
    },
    async submitTaskFn () {
      if (!this.inprocess) {
        this.inprocess = true
        this.formData.startDate = dayjs(this.timeArray[0]).format('YYYY-MM-DD')
        this.formData.closingDate = dayjs(this.timeArray[1]).format('YYYY-MM-DD')
        let res
        try {
        // taskId
        // console.log(data.taskId)
        // console.log(sessionStorage.getItem('walletAddress'))
          let resId = ''
          if (!this.formData.id) {
            resId = await getId()
            if (!resId.code) {
              this.formData.id = resId.data.id
            }
          }
          const createTaskCode = await saveMyTask(this.formData)
          if (!createTaskCode.code) {
            const taskId = this.formData.id
            // const tokenAddress = 'cfxtest:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa6f0vrcsw'
            const tokenAddress = this.tokenAddress
            // const tokenAddress = 'cfxtest:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa6f0vrcsw'
            const unitPrice = this.formData.unitPrice * 1000000000000000000
            // const maxWorkers = this.Data.totalAwards
            const maxWorkers = this.formData.numberOf
            console.log(taskId, tokenAddress, unitPrice, maxWorkers)
            console.log(sessionStorage.getItem('walletAddress'))
            // 打开钱包
            const accounts = await conflux.request({ method: 'cfx_requestAccounts' }) // 打开钱包
            if (accounts[0] !== sessionStorage.getItem('walletAddress')) {
              this.$message({
                type: 'warning',
                offset: 120,
                message: this.$t('allTip.tip27')
              })
              eventBus.$emit('openWallet')
              this.$router.push({ name: 'Index' })
              return
            }
            // console.log(this.$root.contract)
            if (Number(this.formData.totalAwards) !== 0) {
              const objC = {
                from: accounts[0],
                gas: 140000,
                gasPrice: 10001
              } // 提交对象
              if (this.paymentTokensList.filter(item => item.id === this.formData.paymentTokensId)[0]?.name === 'CFX') { // cfx 带value 不是cfx 不带value
                objC.value = this.formData.unitPrice * this.formData.numberOf * 1000000000000000000
              }
              console.log('objC', objC)
              const startTask = await this.$root.contract.addTask(taskId, tokenAddress, unitPrice, maxWorkers).sendTransaction(objC).executed()
              eventBus.$emit('refreshTime')
              res = {
                state: true,
                data: startTask.transactionHash
              }
            }
            // console.log('res', res)
            const submitStatus = submitMyTask({ id: this.formData.id })
            if (!submitStatus.code) {
              setTimeout(() => {
                this.inprocess = false
                this.close()
                this.goBack()
                this.$message({
                  type: 'success',
                  offset: 120,
                  message: 'success'
                })
              }, 500)
            }
          }
        } catch (err) {
          this.inprocess = false
          this.close()
          this.$message.error(err)
          console.log(err)
        }
      } else {
        // tip24
        this.$message.warning(this.$t('allTip.tip24'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.total-rewards{
  position: relative;
  .img-box{
    position: absolute;
    height: 32px;
    display: flex;
    align-items: center;
    right: 100px;
    bottom: 24px;
    padding: 0 8px 0 12px;
    border-left: 1px solid #bbb;
    img{
      width: 32px;
      height: 32px;
      border-radius: 100%;
    }
  }
}
.mb80{
  margin-bottom: 80px;
}
.my-title{
  margin-top: 42px !important;
}
.el-date-editor{
  width: 100%;
}
.bounty-project-detail{
  margin-bottom: 23px;
  margin-top: 72px;
  background: linear-gradient(93.58deg, rgba(167,55,255,.2) 0%, rgba(24,214,190,.2) 100%);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 24px;
}
</style>

<style>
.input-with-select .el-input-group__append {
  /* background-color: #fff; */
  width: 150px;
  padding-right: 0;
}
</style>
